import type { SliceRouteContract } from '@/shared/lib/vsa';
import { PlannerSlicePage } from './PlannerSlicePage';
import { PlannerCalendarSlicePage } from './PlannerCalendarSlicePage';

export const plannerRouteContract: SliceRouteContract = {
  routeId: 'planner',
  component: PlannerSlicePage,
};

export const plannerCalendarRouteContract: SliceRouteContract = {
  routeId: 'planner-calendar',
  component: PlannerCalendarSlicePage,
};
